document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     TABS (DESKTOP + MOBILE)
  ========================================================= */

  const tabsSection = document.querySelector('[data-fhg-tabs]');

  if (tabsSection) {

    const buttons = tabsSection.querySelectorAll('.fhg-ptab-btn');
    const panels  = tabsSection.querySelectorAll('.fhg-ptab-panel');

    let judgeInit = false;

    function initJudgeme() {
      if (judgeInit) return;
      if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
        window.jdgm.initializeWidgets();
        judgeInit = true;
      }
    }

    function activateTab(target) {
      buttons.forEach(btn =>
        btn.classList.toggle('active', btn.dataset.tab === target)
      );

      panels.forEach(panel =>
        panel.classList.toggle('active', panel.dataset.panel === target)
      );

      if (target === 'avaliacoes') {
        requestAnimationFrame(() => initJudgeme());
      }
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        activateTab(btn.dataset.tab);
      });
    });

    if (window.matchMedia('(max-width: 990px)').matches) {
      activateTab('descricao');
      initJudgeme();
    }
  }

  /* =========================================================
     GALERIA (DESKTOP + MOBILE)
  ========================================================= */

  const gallery = document.querySelector('.fhg-pgallery');
  if (!gallery) return;

  const thumbsWrap = gallery.querySelector('.fhg-pgallery-thumbs');
  const thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.fhg-pgallery-thumb')) : [];
  const mainImg = gallery.querySelector('.fhg-pgallery-main-img');
  const counter = gallery.querySelector('.fhg-gallery-counter');

  if (!mainImg || !thumbs.length) return;

  let currentIndex = 0;
  let swapping = false;

  function updateMobileCounter(index){
    if (window.innerWidth > 990) return;
    if (!counter) return;
    counter.textContent = (index + 1) + '/' + thumbs.length;
  }

  function setActive(index) {
    thumbs.forEach((t, i) =>
      t.classList.toggle('is-active', i === index)
    );
  }

  function swapTo(index) {

    if (swapping) return;

    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;

    const t = thumbs[index];
    const full = t.getAttribute('data-full');
    const hires = t.getAttribute('data-hires');

    if (!full) return;

    swapping = true;
    currentIndex = index;

    mainImg.src = full;

    if (hires) {
      mainImg.setAttribute('data-hires', hires);
    }

    setActive(index);
    updateMobileCounter(index);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => swapping = false);
    });
  }

  /* INIT */
  setActive(0);
  updateMobileCounter(0);

  /* THUMBS (DESKTOP) */
  thumbs.forEach((btn, index) => {

    btn.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      swapTo(index);
    });

    btn.addEventListener('click', () => swapTo(index));

  });

  /* =========================================================
     SETAS VERTICAIS DAS THUMBS (DESKTOP)
  ========================================================= */

  if (window.innerWidth >= 991) {

    const wrapper = gallery.querySelector(".fhg-thumbs-wrapper");
    const container = gallery.querySelector(".fhg-pgallery-thumbs");
    const btnUp = gallery.querySelector(".fhg-thumbs-arrow.up");
    const btnDown = gallery.querySelector(".fhg-thumbs-arrow.down");

    if (wrapper && container) {

      const scrollAmount = 100;

      function checkOverflow() {
        if (container.scrollHeight > container.clientHeight) {
          wrapper.classList.add("has-scroll");
        } else {
          wrapper.classList.remove("has-scroll");
        }
      }

      checkOverflow();

      btnUp?.addEventListener("click", function(){
        container.scrollBy({
          top: -scrollAmount,
          behavior: "smooth"
        });
      });

      btnDown?.addEventListener("click", function(){
        container.scrollBy({
          top: scrollAmount,
          behavior: "smooth"
        });
      });

    }
  }

  /* =========================================================
     SWIPE MOBILE
  ========================================================= */

  const mainBox = gallery.querySelector('.fhg-pgallery-main');
  if (!mainBox) return;

  let startX = 0;
  let startY = 0;
  let deltaX = 0;
  let deltaY = 0;
  let touching = false;

  const SWIPE_MIN = 35;

  mainBox.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;
    touching = true;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    deltaX = 0;
    deltaY = 0;
  }, { passive: true });

  mainBox.addEventListener('touchmove', (e) => {
    if (!touching || e.touches.length !== 1) return;

    deltaX = e.touches[0].clientX - startX;
    deltaY = e.touches[0].clientY - startY;

    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      e.preventDefault();
    }

  }, { passive: false });

  mainBox.addEventListener('touchend', () => {

    if (!touching) return;
    touching = false;

    if (Math.abs(deltaX) < SWIPE_MIN) return;
    if (Math.abs(deltaY) > Math.abs(deltaX)) return;

    if (deltaX < 0) swapTo(currentIndex + 1);
    else swapTo(currentIndex - 1);

  }, { passive: true });

  /* =========================================================
     ZOOM DESKTOP
  ========================================================= */

  if (window.innerWidth >= 991) {

    const zoomWindow = gallery.querySelector('.fhg-zoom-window');
    if (!zoomWindow) return;

    const zoomImg = zoomWindow.querySelector('img');
    if (!zoomImg) return;

    const ZOOM_LEVEL = 2;

    zoomWindow.addEventListener('mousemove', function (e) {

      const rect = zoomWindow.getBoundingClientRect();

      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      zoomImg.style.transformOrigin = `${x * 100}% ${y * 100}%`;
      zoomImg.style.transform = `scale(${ZOOM_LEVEL})`;

    });

    zoomWindow.addEventListener('mouseleave', function () {
      zoomImg.style.transform = 'scale(1)';
      zoomImg.style.transformOrigin = 'center center';
    });

  }
/* =========================================================
   CONTROLE DE QUANTIDADE (PLUS / MINUS)
========================================================= */

const qtyWrap = document.querySelector('.fhg-qty');

if (qtyWrap) {

  const input = qtyWrap.querySelector('input[type="number"]');
  const minusBtn = qtyWrap.querySelector('[data-action="minus"]');
  const plusBtn = qtyWrap.querySelector('[data-action="plus"]');

  if (input) {

    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;

    minusBtn?.addEventListener('click', function () {

      let value = parseInt(input.value) || min;
      value--;

      if (value < min) value = min;

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });

    plusBtn?.addEventListener('click', function () {

      let value = parseInt(input.value) || min;
      value++;

      if (value > max) value = max;

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });

  }

}

});
/* =========================================================
   CALCULO FRETE COM REGRA FRETE GRATIS ACIMA 399,90
========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  const btnFrete = document.getElementById("fhg-calc-frenet");
  const resultado = document.getElementById("fhg-shipping-result");
  const cepInput = document.getElementById("fhg-cep");

  if (!btnFrete || !resultado || !cepInput) return;

  function getVariant() {
    const idInput = document.querySelector('form.fhg-buy-form input[name="id"]');
    if (!idInput) return null;
    return window.fhgVariants.find(v => v.id == idInput.value);
  }

  const FRETE_GRATIS_MINIMO = 399.90;

  const tabela = {
    SP: {
      pac: [25,30,40,45],
      sedex: [30,35,40,50]
    },
    grupo1: {
      estados: ["DF","ES","GO","MG","MS","PR","RJ","RS","SC"],
      pac: [35,50,65,85],
      sedex: [55,80,110,135]
    },
    grupo2: {
      estados: ["BA","MT"],
      pac: [40,55,70,95],
      sedex: [70,100,135,165]
    },
    grupo3: {
      estados: ["CE","PA","PE","TO"],
      pac: [60,75,95,115],
      sedex: [80,125,175,210]
    },
    grupo4: {
      estados: ["AL","AM","AP","PB","PI","RN","RO","SE"],
      pac: [85,100,125,150],
      sedex: [95,150,200,250]
    }
  };

  btnFrete.addEventListener("click", function () {

    const cep = cepInput.value.replace(/\D/g, "");

    if (cep.length !== 8) {
      resultado.innerHTML = "<span style='color:#c00;'>CEP inválido.</span>";
      return;
    }

    resultado.innerHTML = "Calculando...";

    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(res => res.json())
      .then(data => {

        if (!data.uf) {
          resultado.innerHTML = "<span style='color:#c00;'>CEP não encontrado.</span>";
          return;
        }

        const uf = data.uf;
        const variant = getVariant();

        if (!variant) {
          resultado.innerHTML = "Erro ao identificar variante.";
          return;
        }

        const quantidadeInput = document.querySelector('.fhg-qty input[type="number"]');
        const quantidade = quantidadeInput ? parseInt(quantidadeInput.value) : 1;

        const precoUnitario = variant.price / 100;
        const subtotal = precoUnitario * quantidade;
        const pesoUnitarioKg = variant.weight / 1000;
        const pesoTotal = pesoUnitarioKg * quantidade;

        let faixaIndex;

        if (pesoTotal <= 1) faixaIndex = 0;
        else if (pesoTotal <= 4) faixaIndex = 1;
        else if (pesoTotal <= 7) faixaIndex = 2;
        else if (pesoTotal <= 10) faixaIndex = 3;
        else {

          resultado.innerHTML = `
            <div class="fhg-rate">
              <div style="margin-bottom:6px;">
                <strong>Frete sob consulta</strong>
              </div>
              <small>
                Peso total do pedido: ${pesoTotal.toFixed(2)} kg.<br>
                Frete será calculado após confirmação do pedido ou pelo WhatsApp.
              </small>
            </div>
          `;

          return;
        }

        let zona;

        if (uf === "SP") zona = tabela.SP;
        else if (tabela.grupo1.estados.includes(uf)) zona = tabela.grupo1;
        else if (tabela.grupo2.estados.includes(uf)) zona = tabela.grupo2;
        else if (tabela.grupo3.estados.includes(uf)) zona = tabela.grupo3;
        else if (tabela.grupo4.estados.includes(uf)) zona = tabela.grupo4;

        if (!zona) {
          resultado.innerHTML = "Região não atendida.";
          return;
        }

        const sedex = zona.sedex[faixaIndex];

        // REGRA FRETE GRATIS
        if (subtotal >= FRETE_GRATIS_MINIMO) {

        resultado.innerHTML = `
          <div class="fhg-frete-gratis">
            🎉 Frete Grátis via PAC ou Transportadora
            <small>Envio definido conforme peso e logística. Prazo informado após despacho.</small>
          </div>
          <div class="fhg-sedex-opcional">
            <strong>SEDEX (opcional):</strong> R$ ${sedex.toFixed(2)}
          </div>
        `;

        } else {

          const pac = zona.pac[faixaIndex];

          resultado.innerHTML = `
          <div class="fhg-rate">
            <div>
              <strong>PAC:</strong> R$ ${pac.toFixed(2)}
            </div>
            <div>
              <strong>SEDEX:</strong> R$ ${sedex.toFixed(2)}
            </div>
            <small>Frete grátis acima de R$ 399,90.</small>
          </div>
        `;

        }

      })
      .catch(() => {
        resultado.innerHTML = "Erro ao calcular frete.";
      });

  });

});
document.addEventListener("DOMContentLoaded", function(){

  const stickyCart = document.getElementById("fhgStickyCart");
  const buyButton = document.querySelector(".fhg-buy-button");

  if(!stickyCart || !buyButton) return;

  window.addEventListener("scroll", function(){

    const rect = buyButton.getBoundingClientRect();

    if(rect.bottom < 0){
      stickyCart.classList.add("active");
    } else {
      stickyCart.classList.remove("active");
    }

  });

});

/* =========================================================
   STICKY ADD TO CART
========================================================= */

document.addEventListener("DOMContentLoaded", function(){

  const sticky = document.getElementById("fhgStickyCart");
  const buyButton = document.querySelector(".fhg-buy-button");
  const stickyBtn = document.querySelector(".fhg-sticky-cart__btn");

  if(!sticky || !buyButton) return;

  /* MOSTRAR / ESCONDER BARRA */

  window.addEventListener("scroll", function(){

    const rect = buyButton.getBoundingClientRect();

    if(rect.bottom < 0){
      sticky.classList.add("active");
    } else {
      sticky.classList.remove("active");
    }

  });

  /* BOTÃO STICKY ADICIONAR AO CARRINHO */

  if(stickyBtn){

    stickyBtn.addEventListener("click", function(){

      const form = document.querySelector(".fhg-buy-form");

      if(form){
        form.dispatchEvent(new Event("submit",{cancelable:true}));
        form.submit();
      }

    });

  }

});

/* =========================================================
   SINCRONIZA QUANTIDADE PDP ↔ STICKY (COM LIMITE ESTOQUE)
========================================================= */

const mainQty = document.querySelector(".fhg-qty input");
const stickyQty = document.querySelector(".fhg-sticky-cart__qty input");
const minus = document.querySelector(".fhg-sticky-cart__qty .qty-minus");
const plus  = document.querySelector(".fhg-sticky-cart__qty .qty-plus");

if(mainQty && stickyQty){

  const min = parseInt(mainQty.getAttribute("min")) || 1;
  const max = parseInt(mainQty.getAttribute("max")) || Infinity;

  function clampQty(v){

    v = parseInt(v) || min;

    if(v < min) v = min;
    if(v > max) v = max;

    return v;

  }

  /* DIGITAÇÃO PDP */
  mainQty.addEventListener("input", function(){

    let v = clampQty(mainQty.value);

    mainQty.value = v;
    stickyQty.value = v;

  });

  /* DIGITAÇÃO STICKY */
  stickyQty.addEventListener("input", function(){

    let v = clampQty(stickyQty.value);

    stickyQty.value = v;
    mainQty.value = v;

  });

  /* BOTÃO - */
  minus?.addEventListener("click",function(){

    let v = clampQty(parseInt(stickyQty.value) - 1);

    stickyQty.value = v;
    mainQty.value = v;

  });

  /* BOTÃO + */
  plus?.addEventListener("click",function(){

    let v = clampQty(parseInt(stickyQty.value) + 1);

    stickyQty.value = v;
    mainQty.value = v;

  });

}